import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
	override parse(value: string | number): Date | null {
		if (typeof value === 'string' && value.length > 0) {
			// Se espera el formato DD/MM/YYYY
			const [day, month, year] = value.split('/').map(Number);
			if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
				return new Date(year, month - 1, day); // Ajustar el mes (0 indexado)
			}
		}
		return super.parse(value);
	}

	override format(date: Date): string {
		const day = date.getDate().toString().padStart(2, '0');
		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	}
}
